module.exports = __webpack_public_path__ + "static/img/topbg_new.f74d6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contribute/topbg_new.png
// module id = jD1y
// module chunks = 0